import React from 'react';
import ReactMarkdown from 'react-markdown';

const markdownComponents = {
  h1: ({ children }) => (
    <h1 className="text-xl font-bold mb-4 text-white border-b border-gray-600 pb-2">{children}</h1>
  ),
  h2: ({ children }) => (
    <h2 className="text-lg font-semibold mb-3 mt-6 text-white">{children}</h2>
  ),
  p: ({ children }) => <p className="text-gray-300 mb-3 leading-relaxed">{children}</p>,
  ul: ({ children }) => (
    <ul className="list-disc list-inside text-gray-300 mb-3 ml-4 space-y-1">{children}</ul>
  ),
  li: ({ children }) => <li className="text-gray-300">{children}</li>,
  a: ({ href, children }) => (
    <a href={href} className="text-white hover:underline">
      {children}
    </a>
  ),
};

const LegalModal = ({ isOpen, title, contentType, privacyContent, termsContent, onClose }) => {
  if (!isOpen) return null;

  const content = contentType === 'privacy' ? privacyContent : termsContent;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-[#343541] rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-white">{title}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="prose prose-invert max-w-none">
          <ReactMarkdown components={markdownComponents}>{content}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export { LegalModal };
